import useFacebookPixels from 'hooks/useFacebookPixels';

const FacebookPixelWrapper: React.FC = ({ children }) => {
  // TEMPORARILY DISABLED WHILE EMBEDDED IN OTHER SITE
  // useFacebookPixels();
  return <>{children}</>;
};

export default FacebookPixelWrapper;
